const clientLogger = {
  error: (message, error = '') => {
    sendLogToServer(message, { error });
  },
  warn: (message, warning = '') => {
    sendLogToServer(message, { warning });
  },
  info: (message, data = {}) => {
    sendLogToServer(message, { data });
  }
};

const sendLogToServer = (message, { error, warning, data }) => {
  try {
    if (typeof window !== 'undefined') {
      fetch('/merchantapps/log', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          message,
          error: parseError(error),
          warning: parseError(warning),
          data
        })
      })
        .then(res => res.json())
        .then(() => {})
        .catch(() => {});
    }
  } catch (err) {
    // This passes lint.
  }
};

const parseError = err => {
  if (typeof err === 'undefined') {
    return '';
  } else if (err instanceof Error) {
    return err.toString();
  } else if (typeof err === 'string') {
    return err;
  }
  return JSON.stringify(err);
};

export { clientLogger };
